import React from 'react'
import { Grid, GridItem } from '@deal/components'
import styles from './styles.css'

interface SimplePageHeaderProps {
  pageLabel?: React.ReactNode
  title: React.ReactNode
  subTitle?: React.ReactNode
  rightContent?: React.ReactNode
}

const SimplePageHeader: React.SFC<SimplePageHeaderProps> = ({
  title,
  pageLabel,
  subTitle,
  rightContent
}) => {
  return (
    <Grid>
      <GridItem col={2} mdCol={rightContent ? 6 : 12} className={styles.headerContent}>
        {pageLabel && <div className={styles.pageLabel}>{pageLabel}</div>}
        <div className={styles.headerTitle}>{title}</div>
        {subTitle && <div className={styles.headerSubtitle}>{subTitle}</div>}
      </GridItem>
      {rightContent && (
        <GridItem col={2} mdCol={6}>
          {rightContent}
        </GridItem>
      )}
    </Grid>
  )
}

export default SimplePageHeader
